import { render, staticRenderFns } from "./FacebookAd.vue?vue&type=template&id=24feef72&scoped=true"
import script from "./FacebookAd.vue?vue&type=script&lang=js"
export * from "./FacebookAd.vue?vue&type=script&lang=js"
import style0 from "./FacebookAd.vue?vue&type=style&index=0&id=24feef72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24feef72",
  null
  
)

export default component.exports